export interface PasswordChecks {
  length: boolean;
  number: boolean;
  uppercase: boolean;
  symbol: boolean;
}

export function getPasswordChecks(password: string): PasswordChecks {
  return {
    length: password.length >= 8,
    number: /\d/.test(password),
    uppercase: /[A-Z]/.test(password),
    symbol: /[@$!%*?&#]/.test(password),
  };
}

export function isPasswordValid(password: string): boolean {
  const checks = getPasswordChecks(password);
  return Object.values(checks).every((v) => v);
}
